<template>
	<div class="edit-route-content">
		<el-dialog
			title="路线编排"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:fullscreen="true"
			:before-close="handleClose"
			:modal="false"
		>
			<span slot="title" class="flex flex-middle">
				<div class="title">
					路线编排: {{ route.routeName }}
					<img
						class="back-btn"
						src="@/assets/images/back.png"
						title="返回"
						alt=""
						@click="handleClose"
					/>
				</div>
				配送周期：
				<el-select
					v-model="deliveryCycle"
					class="w100"
					size="small"
					placeholder="选择"
					@change="getRouteInfo"
				>
					<el-option label="全部" value=""></el-option>
					<el-option
						v-for="(v, i) in weeklist"
						:label="v.label"
						:value="v.value"
					></el-option>
				</el-select>
			</span>
			<div class="content">
				<div class="left">
					<el-table
						border
						:data="agentList"
						:height="tableHeight"
						:header-cell-style="{
							background: 'rgba(200, 204, 215,.6)',
							color: '#333333'
						}"
						:cell-style="cellStyle"
						@cell-click="handleCellClick"
					>
						<el-table-column align="center" label="序号" width="40" type="index">
						</el-table-column>
						<el-table-column prop="agentName" label="客商简称">
						</el-table-column>
						<el-table-column label="位置" width="40" align="center">
							<template slot-scope="scope">
								<img
								class="icon-img"
								:src="routePositionStatus[scope.row.posStatus]"
								title="地图"
								@click="handlePoint(scope.row)"
							/>
							</template>
						</el-table-column>
						<el-table-column label="调序" width="70">
							<template slot-scope="scope">
								<i
									class="el-icon-bottom ml15 cursor-pointer"
									v-if="(scope.$index+1) != agentList.length"
									@click="sortDown(scope.row, 2)"
								></i>
								<i
									class="el-icon-top ml15 cursor-pointer"
									v-if="scope.$index > 0"
									@click="sortDown(scope.row, 1)"
								></i>

							</template>
						</el-table-column>
						<el-table-column prop="channelName" label="渠道" width="60" align="center">
						</el-table-column>
					</el-table>
				</div>
				<div class="right">
					<div id="editRouteContainer"></div>
				</div>
			</div>
		</el-dialog>
		<sortAgent ref="sortAgent" @getRouteInfo="getRouteInfo"></sortAgent>
		<editPoint ref="editPoint" @getRouteInfo="getRouteInfo"></editPoint>
		<sortEdit ref="sortEdit" @getList="getRouteInfo"></sortEdit>
	</div>
</template>
<script>
import initMap from "@/utils/amap.js"
import sortAgent from "../../map/components/sort-agent.vue"
import editPoint from "../../map/components/edit-point.vue"
import sortEdit from "./sort-edit.vue"
export default {
	components: {
		sortEdit,
		sortAgent,
		editPoint
	},
	data() {
		return {
			dialogVisible: false,
			weeklist: [
				{
					value: "1",
					label: "周一"
				},
				{
					value: "2",
					label: "周二"
				},
				{
					value: "3",
					label: "周三"
				},
				{
					value: "4",
					label: "周四"
				},
				{
					value: "5",
					label: "周五"
				},
				{
					value: "6",
					label: "周六"
				},
				{
					value: "0",
					label: "周日"
				}
			],
			deliveryCycle: '',
			// 当前路线信息
			route: null,
			// 当前组织id
			groupId: null,
			// 店铺列表
			agentList: [],
			agentName: "",
			agentAddress: "",
			AMap: null, //保存地图api，防止报错
			map: null,
			tableHeight: 500,
			// 路线状态
			routePositionStatus: {
				0: require('@/assets/images/map_0.png'),
				1: require('@/assets/images/map_1.png'),
				2: require('@/assets/images/map_2.png'),
			},
			// 开始点
			startLngLat: null,
			endLngLat: null,
			waypoints: [],
			driving: null
		};
	},
	methods: {
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0 || columnIndex == 1) {
				return {
					"cursor": "pointer"
				};
			}
		},
		init(route) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				// 当前路线信息
				this.route = route;
				// 当前路线信息包含agent列表
				this.groupId = route.groupId;
				// 店铺列表
				this.agentList = [];
				// 列表高度
				this.tableHeight = window.innerHeight - 64;
				// 路线规划
				this.driving = null;
				// 配送周期初始化
				this.deliveryCycle = '';
				// 初始化地图
				this.initAMap();
			});
		},
		// 获取路线数据
		getRouteInfo() {
			this.$request
				.post("routeMapRAgentList", true, {
					routeId: this.route.routeId,
					deliveryCycle: this.deliveryCycle
				})
				.then(res => {
					// 清除地图marker
					this.map.clearMap();
					this.agentList = res.data;
					this.handleMarkerAndPath();
				});
		},
		// 初始化地图
		initAMap() {
			initMap()
				.then(AMap => {
					this.map = new AMap.Map("editRouteContainer", {
						zoom: 11,
						zooms: [2, 22],
						center: [121.472644, 31.231706] // 初始化地图中心点位置
					});
					this.AMap = AMap;
					// 获取店铺列表
					this.getRouteInfo();
				})
				.catch(err => {
					console.log(err);
				});
		},
		// 调序
		sortDown(agent, type) {
			this.$request.post(
					"routeSort",
					false, {
						deliveryCycle: this.deliveryCycle,
						recordId: agent.recordId,
						removeFlag: type
					}
				)
				.then((res) => {
					if(res.code == "0") {
						this.$message.success(type == 1 ? '上移成功！' : '下移成功！');
						this.getRouteInfo();
					}
				})
		},
		// 点击客商简称调序
		handleCellClick(row, column, cell, event) {
			if(column.label == '客商简称') {
				row.agentType = "route";
				this.$refs.sortAgent.init(row, this.groupId);
			}
			else if (column.label == "序号") {
				this.$refs.sortEdit.init(row, this.deliveryCycle);
			}
		},
		// 点击地图取点
		handlePoint(agent) {
			this.$refs.editPoint.init(agent);
		},
		handleMarkerAndPath() {
			for (let index = 0; index < this.agentList.length; index++) {
				const agent = this.agentList[index];
				if (agent.posLat) {
					// if(this.startLngLat) {
					// 	if(this.waypoints.length > 16) {
					// 		this.endLngLat = new AMap.LngLat(agent.posLng, agent.posLat);
					// 	}else {
					// 		this.waypoints.push(new AMap.LngLat(agent.posLng, agent.posLat));
					// 	}
					// }else {
					// 	this.startLngLat = new AMap.LngLat(agent.posLng, agent.posLat);
					// }
					// 点标记显示内容，HTML要素字符串
					var markerContent = `
						<div class="custom-content-marker1">
							<svg t="1709524045221"
								class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8682" width="40" height="40">
								<path d="M831.488 436.224c0-176.435-143.053-319.488-319.488-319.488S192.512 259.789 192.512 436.224c0 69.018 22.118 132.71 59.187 184.934h-0.205l3.482 4.301a341.06 341.06 0 0 0 18.944 23.245l238.387 259.174 238.694-260.096c6.144-6.861 11.878-14.131 17.408-21.504l4.198-5.12h-0.307c37.069-52.224 59.187-115.917 59.187-184.934z"
								p-id="8683" fill="#d81e06"></path>
							</svg>
							<div>${index + 1}</div>
						</div>
					`;

					let marker = new AMap.Marker({
						content: markerContent,
						position: [agent.posLng, agent.posLat]
					});
					marker.setMap(this.map);
					marker.on('mouseover', function(e) {
						// label
						e.target.setLabel({
							direction: "right",
							offset: new AMap.Pixel(5, 0), //设置文本标注偏移量
							content: `<div>${agent.agentName}</div>`
						});
						e.target.setzIndex(999);
						// 第一次移上去位置不到处理
						let ee = e.target;
						setTimeout(() => {
							ee.setzIndex(999);
							ee.setLabel({
								direction: "right",
								offset: new AMap.Pixel(5, 0), //设置文本标注偏移量
								content: `<div class="zindex">${agent.agentName}</div>`
							});
						}, 50);
					});
					marker.on('mouseout', function(e) {
						// label
						e.target.setLabel({
							direction: "right",
							offset: new AMap.Pixel(5, 0), //设置文本标注偏移量
							content: ''
						});
						e.target.setzIndex(10);
						// 第一次移上去位置不到处理
						let ee = e.target;
						setTimeout(() => {
							ee.setzIndex(10);
							ee.setLabel({
								direction: "right",
								offset: new AMap.Pixel(5, 0), //设置文本标注偏移量
								content: ''
							});
						}, 100);
					});
					agent.agentMarker = marker;
				} else {
					agent.agentMarker = null;
				}
			}
			// 路线规划
			// if(this.agentList.length > 1) {
			// 	this.setDriving();
			// }
			// 地图视野自适应
			this.map.setFitView();
		},
		// 关闭页面注销地图
		handleClose() {
			this.map?.destroy();
			this.$emit("selectRows");
			this.dialogVisible = false;
		},
		// 路线规划
		setDriving() {
			//构造路线导航类
			var driving = new AMap.Driving({
				map: this.map,
				hideMarkers: true
			});
			if(this.waypoints.length < 16) {
				this.endLngLat = this.waypoints[this.waypoints.length - 1];
				this.waypoints.pop();
			}
			// 根据起终点经纬度规划驾车导航路线
			driving.search(
				this.startLngLat,
				this.endLngLat,
				{
					waypoints: this.waypoints
				},
				function(status, result) {
					console.log(status)
					console.log(result)
				}
			);
			this.driving = driving;
		}
	}
};
</script>
<style lang="scss" scoped>
.content {
	display: flex;
	.left {
		width: 400px;
	}
	.right {
		flex: 1;
	}
}
#editRouteContainer {
	height: calc(100vh - 64px);
}

.delete-icon {
	width: 24px;
	height: 24px;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}
.edit-route-content /deep/ .el-dialog__body {
	padding: 0 !important;
}
.edit-route-content /deep/ .el-table .cell,
.edit-route-content /deep/ .el-table .el-table__cell,
.edit-route-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 0;
}
.edit-route-content /deep/ .el-table .cell,
.edit-route-content /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding-left: 0;
}
.icon-s {
	width: 32p;
	height: 32px;
	cursor: pointer;
}
.cursor-pointer {
	cursor: pointer;
}
::v-deep .amap-marker-label {
	border: none;
	background: rgba(0, 0, 0, 0.6);
	color: #fff;
	padding: 8px;
	border-radius: 5px;
}
::v-deep .amap-sug-result {
	z-index: 99999;
}
.back-btn{
	width: 32px;
	height: 32px;
	vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
}
.title{
	margin-right: 100px;
}
.w100{
	width: 100px;
}
</style>
<style>
.custom-content-marker1{
	position: relative;
	width: 40px;
	height: 40px;
}
.custom-content-marker1>div{
	position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0;
    color: white;
    text-align: center;
    font-size: 12px;
    line-height: 32px;
}
.amap-sug-result {
	z-index: 99999;
}
.zindex{
	z-index: 99999;
}
</style>
